<template>
  <div class="relative">
    <div
      class="fixed lg:inset-y-0 lg:flex lg:flex-col transition-all duration-300 bg-white border-r border-gray-200 h-screen"
      :class="[isCollapsed ? 'w-24' : 'w-72', sidebarZIndex]"
    >
      <button
        @click="toggleSidebar"
        class="absolute top-10 flex justify-center items-center bg-white border-2 border-base-gray-lighter p-2 rounded-full transition-all w-[37px] h-[37px] cursor-pointer outline-none focus:outline-none"
        :class="{ 'left-[74px]': isCollapsed, 'left-[268px]': !isCollapsed }"
      >
        <base-icon
          name="sidebar-arrow"
          class="text-base-gray-light cursor-pointer"
          :class="{
            'transform rotate-180': !isCollapsed,
            'transform rotate-0': isCollapsed
          }"
        />
      </button>
      <div class="flex grow flex-col gap-y-5 border-r border-gray-200 bg-white">
        <div class="flex h-16 shrink-0 items-center px-6">
          <transition name="slide-fade">
            <router-link
              to="/"
              class="flex items-center text-base-gray-dark text-sm font-normal leading-normal outline-none focus-visible:outline-none h-auto w-full px-2 py-9"
              v-show="!isCollapsed"
            >
              <base-icon
                name="julmar"
                class="text-base-gray-dark max-w-[125px] h-auto"
              />
            </router-link>
          </transition>
        </div>
        <nav class="flex flex-1 flex-col justify-between px-6">
          <div>
            <ul role="list" class="flex flex-1 flex-col">
              <li>
                <router-link
                  to="/admin/usuarios"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/usuarios'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="user" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span v-show="!isCollapsed">Usuarios</span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/usuarios'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
              <li>
                <router-link
                  to="/admin/catalogo"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/catalogo'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="catalog" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span v-show="!isCollapsed">Catálago</span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/catalogo'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
              <li>
                <router-link
                  to="/admin/banners"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/banners'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="banners" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span v-show="!isCollapsed">Banners</span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/banners'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
              <li>
                <router-link
                  to="/admin/pedidos"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/pedidos'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="orders" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span v-show="!isCollapsed">Pedidos</span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/pedidos'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
              <li>
                <router-link
                  to="/admin/reclamos"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/reclamos'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="claims" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span v-show="!isCollapsed">Reclamos</span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/reclamos'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
              <li>
                <router-link
                  to="/admin/subir"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-base-gray-darker text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/subir'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="upload" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span class="min-w-max block" v-show="!isCollapsed">
                        Subir
                      </span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/subir'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
              <li>
                <router-link
                  to="/admin/chat"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-base-gray-darker text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/chat'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="chat" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span class="min-w-max block" v-show="!isCollapsed">
                        Chat
                      </span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/chat'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
            </ul>
          </div>

          <div>
            <ul role="list" class="flex flex-1 flex-col">
              <li>
                <router-link
                  to="/admin/configuracion"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-base-gray-darker text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20"
                  :class="[
                    $route.path === '/admin/configuracion'
                      ? isCollapsed
                        ? 'text-base-yellow'
                        : 'text-black font-bold'
                      : 'text-base-gray-darker'
                  ]"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="settings" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span v-show="!isCollapsed">Configuracion</span>
                    </transition>
                  </div>
                  <base-icon
                    v-if="$route.path === '/admin/configuracion'"
                    name="chevron-menu"
                    class="w-3 h-3"
                  />
                </router-link>
              </li>
              <li>
                <button
                  type="button"
                  @click="logout"
                  class="flex justify-between items-center w-full max-w-[255px] h-[52px] rounded-[10px] pl-2.5 pr-5 text-base-gray-darker text-[clamp(0.875rem,-0.9855rem+2.3256vw,1rem)] outline-none focus:outline-none"
                  activeClass="bg-base-yellow bg-opacity-20 text-black font-bold"
                >
                  <div
                    class="flex gap-x-2 w-[clamp(18.75rem,6.977vw+13.169rem,19.125rem)]"
                  >
                    <base-icon name="turn-off" class="w-[22px] h-[22px]" />
                    <transition name="slide-fade">
                      <span v-show="!isCollapsed">Salir</span>
                    </transition>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </nav>
        <div class="w-full px-6 pb-4 relative">
          <div class="h-[15px]">
            <transition name="slide-fade">
              <span class="text-[10px] min-w-max block" v-show="!isCollapsed">
                Todos los derechos reservados
                <strong>Julmar &reg; 2025</strong>
              </span>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div
      class="min-h-screen bg-[#EBECEF]"
      :class="{ 'lg:pl-24': isCollapsed, 'lg:pl-72': !isCollapsed }"
    >
      <main class="p-3 2xl:p-5">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminLayout',
  components: {
    BaseIcon
  },
  data() {
    return {
      isCollapsed: false,
      showModal: false,
      modalClosed: false
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    sidebarZIndex() {
      return this.showModal && this.modalClosed ? 'z-30' : 'z-0'
    }
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
    },
    async logout() {
      this.$store.dispatch('afterSuccessLogin', null)
      this.$storage.removeStorageSync('loggedUser')
      this.$storage.removeStorageSync('showModal')
      this.$router.replace('/admin/login')
    },
    updateModalState() {
      this.showModal = !!this.$storage.getStorageSync('showModal')
    },
    listenForModalChanges() {
      window.addEventListener('storage', this.updateModalState)
      document.addEventListener('updateModalState', this.updateModalState)
    },
    removeModalListeners() {
      window.removeEventListener('storage', this.updateModalState)
      document.removeEventListener('updateModalState', this.updateModalState)
    }
  },
  async created() {
    this.emitter.on('update-modal-state', () => {
      this.updateModalState()
    })

    this.emitter.on('modal-opened', () => {
      this.modalClosed = false
    })
    this.emitter.on('modal-closed', () => {
      this.modalClosed = true
    })
  },
  mounted() {
    this.updateModalState()
    this.listenForModalChanges()
  },
  beforeUnmount() {
    this.removeModalListeners()
  },
  watch: {
    showModal() {
      this.updateModalState()
    }
  }
}
</script>

<style scoped>
.cart-active.router-link-active {
  background-color: rgba(75, 141, 114, 0.1);
  color: #4b8d72;
  border-bottom: 2px solid #4b8d72;
}
.slide-fade-enter-active {
  transition: transform 0.3s ease-out, opacity 0.3s;
}
.slide-fade-leave-active {
  transition: transform 0.2s ease-in, opacity 0.2s;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
</style>
